import React from "react"
import { Phone16, Location16, Link16, Email16 } from "@carbon/icons-react"
import { useTranslation } from "react-i18next"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import { formatDistance, dealerMarkerIcon } from "../modules/DealerMap"

const buildMapsDestinationString = (address, postcode, city, lat, lng) => {
  return encodeURIComponent(`${address},${postcode},${city}`)
}

const fixDealerLink = (link) => {
  if (link.indexOf("http://") === 0) return link
  else if (link.indexOf("https://") === 0) return link
  else return `http://${link}`
}

const PhoneDetails = ({ phone }) => {
  if (!phone) return null
  return (
    <div>
      <Phone16 className="inline-block" />
      &nbsp;
      <a className="hover:text-primary" href={`tel:${phone}`}>
        {phone}
      </a>
    </div>
  )
}

const MailDetails = ({ email }) => {
  if (!email) return null
  return (
    <div>
      <Email16 className="inline-block" />
      &nbsp;
      <a className="hover:text-primary" href={`mailto:${email}`}>
        {email}
      </a>
    </div>
  )
}

const LinkDetails = ({ link, external_link }) => {
  if ((!link || link === "+") && (!external_link || external_link === "+"))
    return null

  const validLink =
    external_link && external_link !== link ? external_link : link
  return (
    <div>
      <Link16 className="inline-block" />
      &nbsp;
      <a
        className="hover:text-primary"
        target="_blank"
        rel="noreferrer"
        href={fixDealerLink(validLink)}
      >
        {validLink}
      </a>
    </div>
  )
}

export const LocationDetails = ({
  address,
  postcode,
  city,
  latitude,
  longitude,
  children,
  variant = "default",
}) => {
  const margin = variant === "default" ? "mt-5" : "mt-0"
  return (
    <a
      className={"btn btn-primary w-fit " + margin}
      target="_blank"
      rel="noreferrer"
      href={`https://www.google.de/maps/dir/?api=1&destination=${buildMapsDestinationString(
        address,
        postcode,
        city,
        latitude,
        longitude
      )}`}
    >
      {children}
    </a>
  )
}

export const DistanceDetails = ({ number, calculateDistance, distance }) => {
  return (
    <div className="flex items-center gap-2">
      {dealerMarkerIcon(number, "table")}
      <span className="font-semibold">
        {calculateDistance ? formatDistance(distance) : "-"}
      </span>
    </div>
  )
}

const DealerDetails = ({
  marker,
  variant = "infoWindow",
  number,
  ...props
}) => {
  const { t } = useTranslation()
  const displayDistance = number != null

  return (
    <div {...props}>
      {variant === "infoWindow" && displayDistance && (
        <DistanceDetails
          calculateDistance={true}
          number={number}
          distance={marker.distanceValue}
        />
      )}
      <Headline headlineLevel="h5" headline={marker.name} />
      <div className="pb-5 text-sm text-black">
        <p className="pb-1">
          {marker.address}, {marker.postcode} {marker.city}
        </p>
        <PhoneDetails phone={marker.phone} />
        <MailDetails email={marker.email} />
        <LinkDetails link={marker.link} external_link={marker.external_link} />
        {variant === "infoWindow" && (
          <LocationDetails
            address={marker.address}
            postcode={marker.postcode}
            city={marker.city}
            latitude={marker.latitude}
            longitude={marker.longitude}
          >
            {t("generic.dealer_table.routeButtonLabel")}
          </LocationDetails>
        )}
      </div>
    </div>
  )
}

export default DealerDetails
